var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-text-field', _vm._b({
    on: {
      "input": _vm.emit,
      "blur": _vm.checkUsername
    },
    model: {
      value: _vm.username,
      callback: function ($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  }, 'v-text-field', _vm.attrs, false));

}
var staticRenderFns = []

export { render, staticRenderFns }